import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { CommonService } from 'src/app/core/common.service';
import { Observable } from 'rxjs';
import { ToastService } from 'src/app/core';

@Component({
  selector: 'eos-phone-number-picker',
  templateUrl: './phone-number-picker.component.html',
  styleUrls: ['./phone-number-picker.component.css']
})
export class PhoneNumberPickerComponent extends FieldType implements OnInit {

  countryCodes: Observable<any[]>;
  selectedCountry: string;

  constructor(
    private commonService: CommonService) {
    super();
  }

  ngOnInit() {
    this.getCountrycodes();
  }

  addCustomCode(countryCode): {} | boolean {
    const regex = /^(\+)([0-9]*)$/;
    if (countryCode.match(regex)) {
      return {
        display_name: countryCode,
        dial_code: countryCode,
        code: countryCode,
        icon: countryCode
      };
    } else {
      return false;
    }
  }

  getCountrycodes() {
    this.countryCodes = this.commonService.getCountryCodes();
  }
}
